import React from "react";
import AsideNav from "../../components/presentation/AsideNav/AsideNav";
import { TOURNAMENT_ASIDE_NAV_ITEMS } from "./constants";

function RouteTournamentAside() {
  return <AsideNav items={TOURNAMENT_ASIDE_NAV_ITEMS} />;
}

export default RouteTournamentAside;
